export default "__VITE_ASSET__Bbm1OHyL__"